import { createSlice } from "@reduxjs/toolkit";
const CategorySlice = createSlice({
  name: "Category",
  initialState: {
    categries: [],
    offers:[],
  },

  reducers: {
    storeCategory: (state, action) => {
      state.categries = action.payload;
    },
    storeOffers: (state, action) => {
      state.offers = action.payload;
    },
    clearCategory: (state, action) => {
      state.categries = [];
      state.offers = [];
    },
  },
});

export const { storeCategory,storeOffers, clearCategory } = CategorySlice.actions;
export default CategorySlice.reducer;
